import './../../scss/theme/layout/accordion.scss';

window.addEventListener('DOMContentLoaded', () => {
  const hash = location.hash;
  const scrollSpyNav = document.querySelector('.navbar-scrollspy');

  function scrollToPosition(element) {
    setTimeout(function() {
      const elementPosition = window.scrollY + element.getBoundingClientRect().top;
      const elementTop = scrollSpyNav ? elementPosition - scrollSpyNav.offsetHeight : elementPosition;

      window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
      })
    },300);
  }

  if (hash !== null && hash !== "") {
    const accordionItem = document.getElementById(hash.substring(1));
    if (accordionItem) {
      accordionItem.click();
      scrollToPosition(accordionItem);
    }
  }
});


